module.exports = __webpack_public_path__ + "86a959e3cdf58d10b02aa83bc72c475a.png";